import { Box, Typography } from '@mui/material';
import Dialog from './Dialog';
import Button from './Button';
import { getFileTypeFromName } from '../helpers/file';
import { isAllowedFileUrl } from '../helpers/allowedFileUrl';
import { getThemeColors } from '../helpers/themeStyles';

const IMAGE_TYPES = ['png', 'jpeg', 'jpg', 'gif', 'bmp', 'webp'];
const PDF_TYPES = ['pdf'];
const VIDEO_TYPES = ['mp4', 'webm'];
const AUDIO_TYPES = ['mp3'];

const FilePreviewDialog = ({ open, onClose, file }) => {
  if (!file?.url) return null;

  const fileType = getFileTypeFromName(file.fileName);
  const ext = fileType?.toLowerCase();
  const previewOk = isAllowedFileUrl(file.url);
  const downloadTarget = file.downloadUrl || file.url;
  const downloadOk = isAllowedFileUrl(downloadTarget);

  const handleDownload = () => {
    if (!downloadOk || !downloadTarget) return;
    window.open(downloadTarget, '_blank', 'noopener,noreferrer');
  };

  const renderPreview = () => {
    if (!previewOk) {
      return (
        <Box
          sx={(theme) => ({
            textAlign: 'center',
            color: getThemeColors(theme).textSecondary,
            p: 4,
          })}
        >
          <Typography sx={{ mb: 2 }}>
            L’aperçu ne peut pas être affiché : l’URL du fichier n’est pas autorisée.
          </Typography>
        </Box>
      );
    }
    if (IMAGE_TYPES.includes(ext)) {
      return (
        <Box
          component="img"
          src={file.url}
          alt={file.name}
          sx={{
            width: '100%',
            height: '100%',
            objectFit: 'contain',
          }}
        />
      );
    }
    if (PDF_TYPES.includes(ext)) {
      return (
        <Box
          component="iframe"
          src={file.url}
          title={file.name}
          sx={{
            width: '100%',
            height: '100%',
            border: 'none',
          }}
        />
      );
    }
    if (VIDEO_TYPES.includes(ext)) {
      return (
        <Box
          component="video"
          src={file.url}
          controls
          sx={{
            width: '100%',
            height: '100%',
            objectFit: 'contain',
          }}
        />
      );
    }
    if (AUDIO_TYPES.includes(ext)) {
      return <Box component="audio" src={file.url} controls sx={{ width: '100%' }} />;
    }
    return (
      <Box
        sx={(theme) => ({ textAlign: 'center', color: getThemeColors(theme).textSecondary, p: 4 })}
      >
        <Typography sx={{ mb: 2 }}>Aperçu non disponible pour ce type de fichier.</Typography>
      </Box>
    );
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      title={file?.name ?? 'Aperçu du fichier'}
      fullScreen
      PaperProps={{
        sx: (theme) => ({
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
          backgroundColor: getThemeColors(theme).dialogBg,
        }),
      }}
    >
      <Box
        sx={{
          flex: 1,
          minHeight: 0,
          overflow: 'auto',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          p: 2,
        }}
      >
        {renderPreview()}
      </Box>
      <Box sx={{ flexShrink: 0, display: 'flex', justifyContent: 'flex-end', p: 2, gap: 1 }}>
        <Button variant="contained" color="primary" onClick={handleDownload} disabled={!downloadOk}>
          Télécharger
        </Button>
      </Box>
    </Dialog>
  );
};

export default FilePreviewDialog;
